import { createBrowserRouter } from 'react-router-dom';

import App from './App';
import { AboutTest, AboutUs, Faq } from './features/content';
import DashboardLayout from './features/dashboard/DashboardLayout';
import ResultHandler from './features/dashboard/components/ResultHandler';
import DashboardHomePage from './features/dashboard/pages/DashboardHomePage';
import DashboardThemePage from './features/dashboard/pages/DashboardThemePage';
import ImprovementsPage from './features/dashboard/pages/ImprovementsPage';
import SuggestionsPage from './features/dashboard/pages/SuggestionsPage';
import ErrorPage from './features/error/pages/ErrorPage';
import NotFound from './features/error/pages/NotFound';
import ThemePage from './features/result/theme-page';
import { StartSurvey, SurveyPage } from './features/survey/pages';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: '/',
        element: <StartSurvey />,
      },
      {
        path: '/:activationCode',
        element: <StartSurvey />,
      },
      {
        path: '/survey',
        element: <SurveyPage />,
      },
      {
        path: '/',
        element: <DashboardLayout />,
        children: [
          {
            path: '/dashboard',
            element: <DashboardHomePage />,
          },
          {
            path: '/improvements',
            element: <ImprovementsPage />,
          },
          {
            path: '/suggestions',
            element: <SuggestionsPage />,
          },
          {
            path: '/thema',
            element: <DashboardThemePage />,
          },
          {
            path: '/thema/:theme',
            element: <ThemePage />,
          },
          {
            path: '/thema/:theme?activationCode=:activationCode',
            element: <ThemePage />,
          },
        ],
      },
      {
        path: '/about-us',
        element: <AboutUs />,
      },
      {
        path: '/gezondleventest',
        element: <AboutTest />,
      },
      {
        path: '/thema/:theme',
        element: <ThemePage />,
      },
      {
        path: '/thema/:theme?activationCode=:activationCode',
        element: <ThemePage />,
      },
      {
        path: '/faq',
        element: <Faq />,
      },
      {
        path: '/result/:activationCode/:resultCode',
        element: <ResultHandler />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
    errorElement: <ErrorPage />,
  },
]);

export default router;
